module.exports = __webpack_public_path__ + "img/logo.6af8a569.png";